<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.0824 14.38C2.9024 14.38 2.7224 14.32 2.6024 14.17C2.3324 13.9 2.3324 13.48 2.6024 13.21L11.6924 4.12005H4.4324C4.0724 4.12005 3.7724 3.82005 3.7724 3.46005C3.7724 3.10005 4.0724 2.80005 4.4324 2.80005H13.2824C13.6424 2.80005 13.9424 3.10005 13.9424 3.46005V12.37C13.9424 12.73 13.6424 13.03 13.2824 13.03C12.9224 13.03 12.6224 12.73 12.6224 12.37V5.14005L3.5624 14.2C3.4424 14.32 3.2624 14.38 3.0824 14.38Z" fill="white"/>
    </svg>
</template>
<script setup lang="ts">
</script>